export default {
    title: 'Algo salió mal',
    description: 'No encontramos registros que coincidan con el número que ingresó. Intente nuevamente.',
    startOverBtn: 'Comenzar de nuevo',
};
